import React, { useEffect, useState } from "react"
import { Footer } from "../shared/Footer"
import { SidebarMenu } from "../shared/SidebarMenu"
import { NavTopMenu } from "../shared/NavTopMenu"
import {   TextField, Tooltip} from "@material-ui/core"
import "../../styles/carouselStyle.scss"
import { timeSessionDifference } from "../../constants/auth/timeSessionDifference"
import { actionErrorConnection } from "../../constants/component/actionErrorConnection"
import { sesionExpired } from "../../constants/auth/sesionExpired"
import { useDispatch, useSelector } from "react-redux"
import Swal from "sweetalert2"

import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import { deleteImageDispatch, fetchImages } from "../../actions/images"


const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
const IS_IMAGE = true
function ImageAdministrationScreen(props) {

    const [currentIndex] = useState(null)
    const [, setNewFileName] = useState("")
    const [responseArray, setResponseArray] = useState([])
    const [isLoadingEdit] = useState(false)
    const [isLoadingDelete, setIsLoadingDelete] = useState(false)
    const sessionDifference = timeSessionDifference();
    const dispatch = useDispatch()
    const history = useHistory()
    const {images,isLoadingImages, error,reload} = useSelector((state)=>state.images)
    const swalCustomButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn custom-btn',
          cancelButton: 'btn custom-cancel-btn me-3'
        },
        buttonsStyling: false
      });
    // useEffect(()=>{
    //     imageSliderService.getImages(IS_IMAGE).then((response)=>{
    //        const parsedImages =  response.map((el)=>{
    //             const byteString = window.atob(el.data.split(',')[1]);
    //             const mimeString = el.data.split(',')[0].split(':')[1].split(';')[0];
      
    //             const ab = new ArrayBuffer(byteString.length);
    //             const ia = new Uint8Array(ab);
    //             for (let i = 0; i < byteString.length; i++) {
    //               ia[i] = byteString.charCodeAt(i)
    //             }
                
    //             const dataBlob = new Blob([ab], { type: mimeString });
    //             const imageUrl = URL.createObjectURL(dataBlob)
    //             return  {url:imageUrl, alt:el.name ,  size:dataBlob.size, dataType: dataBlob.type }           
    //         })
            
    //     }).catch((error)=>{
    //         setIsLoadingData(false);
    //         if(sessionDifference > Number(tokenExpired)){
    //             sesionExpired(dispatch, history);
    //           } else{
    //             actionErrorConnection(error, 
    //               (error.response && error.response.data) ?'No existen imagenes':'Error al recuperar imagenes');
    //           }
    //     })
    //     //dispatch(fetchCarouselImages())
    //      // eslint-disable-next-line react-hooks/exhaustive-deps
    // },[dispatch])
    useEffect(()=>{
      if(images && images.length > 0) {
        setResponseArray(images)
      }else if (!images && !isLoadingImages && !reload) {
        dispatch(fetchImages(IS_IMAGE))
      }
            // eslint-disable-next-line react-hooks/exhaustive-deps
    },[images])
    if(error){

      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 
            (error.response && error.response.data) ?'No existen imagenes':'Error al recuperar imagenes');
        }
    }
     /**
   * Regresar al homePage
   * @param { string } response - respuesta  swalert
   * @author Kenzo Sashida
   * @version 1.0.0 - Julio 2024
   */
    const getReturnPage = (result) => {
      if (result.isConfirmed) {
        props.history.push('/');
      }
    }
  /**
   * Eliminar la imágen
   * @param {string} fileName - nombre del archivo
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
    const deleteImage =  (fileName) =>{
      setIsLoadingDelete(true)
      swalCustomButtons.fire({
        title: 'Eliminar',
        html: `<span>Esta acción eliminará permanentemente el archivo </span> <span class="text-title-delete-file"> ${fileName}</span>`,
        icon: 'warning',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(deleteImageDispatch(fileName, IS_IMAGE))
          .then(()=>{
              setIsLoadingDelete(false)
              Swal.fire({
                icon: 'success',
                title: 'Archivo eliminado exitosamente',
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
                }).then((result)=> getReturnPage(result))  
            })
            .catch((error) => {
              console.log(error);
              setIsLoadingDelete(false)
              if(sessionDifference > Number(tokenExpired)){
                sesionExpired(dispatch, history);
              } else{
                actionErrorConnection(error, 'Error al borrar archivo.');
              }
            });
        }
      })
      
    };

  /**
   * Edita el nombre de la imágen
   * @param {string} fileName - nombre del archivo
   * @param {string} indx - index del componente imagen seleccionado
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
    // const editImage = async(name,indx) =>{
    //     setIsLoadingEdit(true)
    //     if(indx !== currentIndex) return
    //     const nameObject = {oldName: name, newName: newFileName + ".jpg"}
    //     dispatch(updateImage(nameObject, IS_IMAGE)).then(()=>{
    //       swalCustomButtons.fire({
    //             title: "Operación Exitosa",
    //             text: "Se ha editado la imágen correctamente.",
    //             icon: 'success',
    //             showConfirmButton: true,
    //             confirmButtonText: 'Aceptar',
    //             reverseButtons: true
    //           }).then((response) => {
    //             setIsLoadingEdit(false)
    //             getReturnPage(response)
    //           })
    //     }).catch((error)=>{
    //         setNewFileName("")
    //         setIsLoadingEdit(false)
    //         if(sessionDifference > Number(tokenExpired)){
    //             sesionExpired(dispatch, history);
    //           } else{
    //             actionErrorConnection(error, 
    //               (error.response && error.response.data) ?'No existen Secciones':'Error al recuperar secciones');
    //           }
    //     })

    // }
      /**
   * Toogle para abrir el formulario de edicion
   * @param {string} indx - index del componente imagen seleccionado
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
    // const handleToggleForm = (indx)=>{
    //     setCurrentIndex((prev)=>{
    //         if(prev === indx) return null
    //         else return indx
    //     })
    // }
      /**
   * Establece el nombre del archivo puesto por el usuario
   * @param {string} event - Accede a las propiedades del input seleccionado
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
    const handleInputChange = (event) =>{
        setNewFileName(event.target.value)
    }
          /**
   * Descarga en formato png la imágen seleccionada
   * @param {string} blobUrl -Url de la imágen codificada
   * @param {string} event - nombre del archivo
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
    const downloadBlobImage = (blobUrl, fileName) => {
        const img = new Image(); //crear instancia imágen
        img.crossOrigin = 'Anonymous'; // Permite descargar imágenes de otros dominios
    
        img.onload = function() {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
    
            const ctx = canvas.getContext('2d'); //Obtener contexto de un canvas que renderiza en dos dimensiones
            ctx.drawImage(img, 0, 0);
    
            // Convertir el canvas a un Blob
            canvas.toBlob((blob) => {
                // Crear un enlace para descargar
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
    
                // Limpiar
                URL.revokeObjectURL(url);
            }, 'image/png'); // Tipo de imagen deseado (aquí puedes cambiar a jpeg, por ejemplo)
        };
    
        // Asignar la URL Blob a la imagen
        img.src = blobUrl;
    };
    return (
        <>
        <div className="container-fluid p-0 m-0">
          <div className="row flex-nowrap p-0 m-0">
            <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
              <SidebarMenu />
            </div>
            <div className="col p-0 ms-1 me-1">
              <NavTopMenu />
              <div className="container ps-3 pe-3 container-size">
                <div className="row base-container">
                  <div className="col-12 border-title text-title pt-2 pb-2 ps-4 d-flex align-items-center justify-content-between">
                    <span className="h4">Lista de Imágenes</span>
                    <Tooltip title="Agregar Imágen">
                        <button className="btn custom-btn-icons" onClick={()=>props.history.push("/administration/image-list/create")} >
                            <i className="fas fa-plus-square custom-icon-add"></i>
                        </button>
                    </Tooltip>
                  </div>
                </div>
                <div className="row base-container align-items-center justify-content-center ">

                  { !isLoadingImages && (responseArray && responseArray.length > 0 ?                     
                    responseArray.map((el, index) => (

                    <div key={index} className="row mb-2 align-items-center px-3 mt-3 justify-content-center">
                      <div className="col-sm d-flex flex bd-highlight mb-1 align-items-center ">
                       
                        <div className="d-flex flex-column align-items-center p-2 justify-content-center">
                          <img
                            src={el.url}
                            alt={el.alt}
                            style={{ width: '280px', height: '200px' }}
                          />
                          <div className="ms-1 mt-2">
                          {/* <Tooltip title="Editar" placement="top-start" arrow>
                          { !isLoadingEdit  ?   
                          <button disabled={isLoadingDelete || isLoadingEdit} onClick={()=>handleToggleForm(index)} className="btn-list custom-btn-icons">
                              <i className="fas fa-edit"></i>
                            </button>
                            :
                              currentIndex === index ? 
                                <i className="fas fa-spinner fa-spin"></i>
                              :
                              <button disabled={isLoadingDelete || isLoadingEdit} onClick={()=>handleToggleForm(index)} className="btn-list custom-btn-icons">
                              <i className="fas fa-edit"></i>
                            </button>
                          }


                          </Tooltip>   */}
                            <Tooltip title="Eliminar" placement="top-start" arrow>
                                <button disabled={isLoadingDelete || isLoadingEdit} onClick={()=>deleteImage(el.alt, index)} className="btn-list custom-btn-icons-danger">
                                    <i className="fas fa-trash"></i>
                                </button>
                            </Tooltip>
                            <Tooltip title="Descargar" placement="top-start" arrow>
                                <button className="btn-list custom-btn-icons" 
                                    type="button"
                                    onClick={() => downloadBlobImage(el.url, el.alt)}
                                >
                                    <i className="fas fa-cloud-download-alt"></i>
                                </button>
                            </Tooltip>
                            {/* {currentIndex === index && 
                            <>
                            <div className="mt-1 w-75 mx-auto d-md-none d-flex flex-column align-items-center justify-content-center flex-md-row justify-content-md-start">
                              <input placeholder="Inserte nuevo nombre" className="form-control mb-2 w-100" type="text" />
                              <button disabled={isLoadingDelete || isLoadingEdit} onClick={()=>editImage(el.alt, index)} className="btn btn-sm btn-success w-50">Actualizar</button>
                            </div>
                            </>} */}
                          </div>
                        </div>
                        {currentIndex === index ? (
                            <>
                            <div className="mt-1 w-75 mx-auto d-none d-md-flex flex-column align-items-center">
                              <TextField
                                required
                                className="w-75 mx-2 mb-1"
                                id="name"
                                name="name"
                                label="Nombre de Imágen"
                                type="text"
                                fullWidth
                                
                                variant="outlined"
                                onChange={(event)=>handleInputChange(event)}
                                defaultValue={el.alt}
                                size="small"
                              />
                              {/* <div className="w-75 d-flex justify-content-start mt-3">
                                <button disabled={newFileName === "" || isLoadingEdit || isLoadingDelete} onClick={()=>editImage(el.alt, index)} className="btn btn-sm custom-btn w-50">{isLoadingEdit ? <i className="fas fa-spinner fa-spin"></i> :"Actualizar" }</button>
                              </div> */}
                            </div>
                            </>
                        ) : 
                        <div className="mt-1 w-50 mx-auto d-none d-md-flex flex-column align-items-center">
                              <table className="table">
                                <thead>
                                    <tr>
                                    <th scope="col">Formato</th>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Peso</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <th scope="row">{el.alt.slice(el.alt.indexOf("."))}</th>
                                    <td>{el.alt.slice(0, el.alt.indexOf(".") )}</td>
                                    <td>{el.size}bytes</td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        }
                      </div>
                      <hr className="w-100 my-2" />
                    </div>
                  )):
                  <div className="col-md-12">
                        <div className="w-100 element-row-message border-content-sections d-flex justify-content-center pt-5 pb-5">
                            <span>Documentos no disponibles</span>
                        </div>
                 </div>
                     )}
                    { isLoadingImages &&
                        <div className="col-md-12">
                            <div className="w-100 element-row-message custom-icon-loading border-content-sections d-flex justify-content-center pt-5 pb-5">
                                <i className="fas fa-spinner fa-spin"></i>
                            </div>
                        </div>

                    }
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  

export default ImageAdministrationScreen
ImageAdministrationScreen.propTypes = {
  history: PropTypes.object
}